import { z } from 'zod';

// TODO: Keep this same as Regex in packages/common-utils.
// Importing does not work due to bundling issues, caused by OpenTelemetry
const passwordRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,250}$/);
/** Type for password for new accounts and updated passwords */
export const passwordType = z.string().regex(passwordRegex);

// 'api' repository defines ring serial number as below:
export const RingSerialRegex = /^[A-Z0-9]{8,18}$/;

export function validOuraUserAgent(userAgent: string | undefined): boolean {
  // 'api' repository defines Oura "user-agent" string as below:
  const OuraUserAgentRegex = /^OURA-(?<platform>[a-z]+)-(?<flavor>[a-z]+)\/(?<version>.+)$/;
  return userAgent !== undefined && OuraUserAgentRegex.test(userAgent);
}

export const legacyPasswordType = z.string().max(500); // Needed to allow for legacy passwords

// @todo: add domain specific password validator
export function isPasswordValid(password: string): boolean {
  return passwordType.safeParse(password).success;
}
